import { SyntheticEvent, useContext, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";
import Tab from "@mui/material/Tab";

import { colors } from "@dotnet/telematics-design-system";

import Tabs from "components/DesignComponents/Tabs";
import TaskGroupsTabLoader from "components/Loaders/TaskGroupsTabLoader";
import ParamsContext from "context/params/paramsContext";
import TableContext from "context/table/tableContext";

import { TAB_VALUES } from "./types";

const TabFilters = () => {
    const { gray200 } = colors;

    const {
        queryParams: { approvable },
        setQueryParams
    } = useContext(ParamsContext);

    const { isInitialLoading } = useContext(TableContext);

    const { t } = useTranslation();

    const getValue = () => {
        if (approvable) {
            return approvable as TAB_VALUES;
        } else {
            return TAB_VALUES.All;
        }
    };

    const [value, setValue] = useState<TAB_VALUES>(getValue());

    useEffect(() => {
        setValue(getValue());
        // eslint-disable-next-line
    }, [approvable]);

    const handleChange = (_: SyntheticEvent, newValue: TAB_VALUES) => {
        setQueryParams({
            params: {
                approvable: newValue === TAB_VALUES.All ? "" : String(newValue)
            }
        });
    };

    return (
        <section>
            {isInitialLoading ? (
                <TaskGroupsTabLoader />
            ) : (
                <div
                    css={css({
                        padding: "8px 24px 0 24px",
                        boxShadow: `inset 0px -1px 0px ${gray200}`
                    })}
                >
                    <Tabs
                        variant="scrollable"
                        value={value}
                        onChange={handleChange}
                    >
                        <Tab
                            value={TAB_VALUES.All}
                            label={t("Task groups##all")}
                        />

                        <Tab
                            value={TAB_VALUES.PendingApproval}
                            label={t("Task groups##pending approval")}
                        />
                        <Tab
                            value={TAB_VALUES.AlreadyApproved}
                            label={t("Task groups##already approved")}
                        />

                        <Tab
                            value={TAB_VALUES.NoApprovalRequired}
                            label={t("Task groups##no approval required")}
                        />
                    </Tabs>
                </div>
            )}
        </section>
    );
};

export default TabFilters;
